import { hasConsentForCategory } from './consentManager'
import { CookieCategory } from './CookieCategory'

export const isLocalStorageAvailable = (): boolean => {
  try {
    return typeof localStorage === 'object'
  } catch {
    // Ensure we don't throw due to security sandbox issues e.g. Chrome's
    // "Failed to read 'localStorage' from 'Window': Access denied for this document"
    /* istanbul ignore next */
    return false
  }
}

const tryGetItem = (key: string): string | null => {
  try {
    return getItem(key)
  } catch (error) {
    return null
  }
}
const getItem = (key: string): string | null => {
  if (!isLocalStorageAvailable()) return null
  return localStorage.getItem(key)
}

const trySetItem = (
  key: string,
  value: string,
  category: CookieCategory,
): void => {
  try {
    return setItem(key, value, category)
    // eslint-disable-next-line no-empty
  } catch (_) {}
}

const setItem = (
  key: string,
  value: string,
  category: CookieCategory,
): void => {
  if (!isLocalStorageAvailable()) return
  if (hasConsentForCategory(category)) return localStorage.setItem(key, value)
}

const tryRemoveItem = (key: string): void => {
  try {
    return removeItem(key)
  } catch {
    return undefined
  }
}

const removeItem = (key: string): void => {
  if (!isLocalStorageAvailable()) return
  localStorage.removeItem(key)
}

const clear = (): void => {
  if (!isLocalStorageAvailable()) return
  localStorage.clear()
}

const getLength = (): number => {
  if (!isLocalStorageAvailable()) return 0
  return localStorage.length
}

const key = (index: number): string | null => {
  if (!isLocalStorageAvailable()) return null
  return localStorage.key(index)
}

const keys = (): string[] => {
  if (!isLocalStorageAvailable()) return []
  return Object.keys(localStorage)
}

export const localStore = {
  trySetItem,
  tryGetItem,
  tryRemoveItem,
  setItem,
  getItem,
  removeItem,
  clear,
  key,
  keys,
  get length(): number {
    return getLength()
  },
}
